import homeTypes from '@/ui_builder/homeTypes';
import scheduleFilters from '@/ui_builder/scheduleFilters';
import {SETTINGS_PROPS_TYPES} from '@/const';

export const PASS_DISPLAY_TYPES = {
  CARD: 'card',
  TABLE: 'table',
  TABS: 'tab',
};

export const UI_SCOPES = {
  HOME: homeTypes,
  SCHEDULE_FILTER: scheduleFilters,
};
export const getBuilderTitle = ({customName}) => ({
  type: SETTINGS_PROPS_TYPES.STATIC,
  value: customName,
});
export const getBuilderKey = ({key, customName, type} = {}) => ({
  type: SETTINGS_PROPS_TYPES.STATIC,
  value: key || customName || type,
});
export const prepareBlocksForStore = ({ui, scope}) => {
  const list = ui.filter(
      ({enabled}) => enabled,
  ).toSorted((a, b) => b.weight - a.weight);

  if (!list || !list.length) return Promise.resolve([]);
  return list.map(
      (ui) => componentsMapper({ui, scope}),
  ).filter(Boolean);
};
export const componentsMapper = ({ui, scope}) => {
  const componentName = ui.type;
  const builder = scope[componentName];
  if (!builder) {
    console.warn(`Can't find builder for ${componentName}`, 'ui', ui);
    return;
  }

  return {
    component: builder.component.pathKey,
    dynamicProps: (dynamic) => builder.component.props(dynamic, ui),
  };
};
